import {
    REGISTER_PLAYER,
    RESET_PLAYER,
    PLAYER_READY,
    AUTOEMBED_TIMER_COMPLETE,
    STREAM_PLAYING,
    AUTHORIZATION_ERROR,
    AUTOPLAY_UPDATED,
    PLAYER_EMBEDDING,
    PLAYER_EMBEDDED,
    FEED_SELECT,
    FEED_RESET
} from '../actions';

export default function page(state = {
    autoEmbedTimerComplete: false,
    embedding: false,
    embedded: false,
    ready: false,
    error: false,
    feeds: {}
}, action) {
    switch (action.type) {
        case AUTHORIZATION_ERROR:
            return { ...state, error: true, message: action.message };
        case AUTOEMBED_TIMER_COMPLETE:
            return { ...state, autoEmbedTimerComplete: true };
        case AUTOPLAY_UPDATED:
            return { ...state, autoEmbed: action.autoplay };
        case STREAM_PLAYING:
            return { ...state, error: action.error };
        case PLAYER_READY:
            return { ...state, autoEmbed: action.autoEmbed, ready: action.ready };
        case PLAYER_EMBEDDING:
            return { ...state, embedding: action.embedding };
        case PLAYER_EMBEDDED:
            return { ...state, embedded: action.embedded };
        case REGISTER_PLAYER:
            return { ...state, ready: action.ready };
        case RESET_PLAYER:
            return {
                ...state,
                autoEmbedTimerComplete: false,
                embedding: false,
                embedded: false,
                ready: false,
                error: false
            };
        case FEED_SELECT:
            if (!action.content || !action.content.id) {
                return state;
            }
            return {
                ...state,
                feeds: {
                    ...state.feeds,
                    [action.content.id]: action.streamId
                }
            };
        case FEED_RESET:
            return { ...state, feeds: {} };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/webapp/player/reducers/index.js